import _ from 'lodash';

export const filterComboBoxHealthInsuranceTypeWhenExist = comboBoxHealthInsuranceType => {
  let newComboBoxHealthInsuranceType = _.cloneDeep(comboBoxHealthInsuranceType);
  const required = [
    '健康保険組合',
    '協会けんぽ（全国健康保険協会）',
    '各種共済組合',
    '船員保険（全国健康保険協会）',
  ];
  newComboBoxHealthInsuranceType = _.filter(
    comboBoxHealthInsuranceType,
    item => {
      return _.includes(required, item.health_insurance_type);
    }
  );
  return newComboBoxHealthInsuranceType;
};

export const filterComboBoxHealthInsuranceTypeWhenExclusion = (
  comboBoxHealthInsuranceType,
  reason
) => {
  let newComboBoxHealthInsuranceType = _.cloneDeep(comboBoxHealthInsuranceType);
  let options;
  switch (reason) {
    case 'けんぽ適用除外承認済':
      options = ['国民健康保険組合'];
      break;
    case '５人未満個人事業所':
    case '常用以外の短時間労働者':
    case '日雇労働者':
    case '臨時労働者':
    case '季節的業務':
    case '巡業・興業':
    case '臨時的事業':
    case '個人事業主と家族従事者':
      options = ['国民健康保険', '国民健康保険組合'];
      break;
    case '後期高齢者医療対象者':
      options = ['後期高齢者医療制度'];
      break;
    case 'その他':
      options = [''];
      break;
    case null:
      options = [''];
      break;
    case '':
      break;
    default:
      return newComboBoxHealthInsuranceType;
  }
  newComboBoxHealthInsuranceType = _.filter(
    comboBoxHealthInsuranceType,
    item => {
      return _.includes(options, item.health_insurance_type);
    }
  );
  return newComboBoxHealthInsuranceType;
};

export const filterComboBoxPensionTypeWhenExist = comboBoxPensionType => {
  let newComboBoxPensionType = _.cloneDeep(comboBoxPensionType);
  const required = ['厚生年金'];
  newComboBoxPensionType = _.filter(comboBoxPensionType, item => {
    return _.includes(required, item.pension_type);
  });
  return newComboBoxPensionType;
};

export const filterComboBoxPensionTypeWhenExclusion = comboBoxPensionType => {
  let newComboBoxPensionType = _.cloneDeep(comboBoxPensionType);
  const required = ['国民年金'];
  newComboBoxPensionType = _.filter(comboBoxPensionType, item => {
    return _.includes(required, item.pension_type);
  });
  return newComboBoxPensionType;
};



// WEBPACK FOOTER //
// ./src/utilities/insuranceFormUtil.js